import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=1156982b&scoped=true&"
import script from "./ToggleButton.vue?vue&type=script&lang=js&"
export * from "./ToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=1156982b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156982b",
  null
  
)

export default component.exports